<template>
  <div id="page-layout">
    <form class="edit-form login-form"
          novalidate
          @submit.prevent="handleSubmit"
          name="forgot-password">

      <h1 class="big-title">{{ $t("titles.forgot_password") }}</h1>

      <c-input ref="email" name="email" label="user.email" v-model.trim="login.email" type="email"/>

      <div class="actions login-actions">
        <input
          class="solid-button"
          style="flex-grow: 2"
          type="submit"
          v-bind:value="$t('actions.send_mail')">
        <input
          class="ghost-button"
          style="flex-grow: 1"
          type="button"
          v-on:click="onGoBack()"
          v-bind:value="$t('actions.go_back')">
      </div>
    </form>
  </div>
</template>
<script>
  import LoginUser from "../models/LoginUser.js";
  import userService from "../services/userService.js";

  export default {
    data() {
      return {
        login: new LoginUser()
      };
    },
    methods: {
      onGoBack() {
        this.$router.go(-1);
      },
      handleSubmit() {
        userService.requestPasswordReset(this.login.email, this.getCurrentUrl())
          .then(() => {
            // We don't want to tell the user if the email doesn't exist
            this.$store.dispatch('alert/success', this.$t("alerts.request_password_success", {name: this.login.email}));
            this.clearField();
          })
      },
      getCurrentUrl() {
        return window.location.protocol + "//" + window.location.hostname + ":" + window.location.port
      },
      clearField() {
        this.$refs.email.clear();
      }
    }
  };
</script>
<style lang="scss" scoped>
  @import "../style/form.scss";

  #page-layout {
    display: grid;
    grid-template-columns: 30% [content] auto 30%;
    padding-top: 8%;
    padding-bottom: 4%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/forgotPassword.vue